import React, { useState, useEffect } from "react";
import { jwtDecode } from "jwt-decode";

import {
  TOOLTIP_STORAGE_KEY_PROVIDER,
  TOOLTIP_STORAGE_KEY_CONSUMER,
} from "../FeatureTooltip/fetures";

import "./style.scss";

export default function DownloadButton() {
  const [stopAnimation, setStopAnimation] = useState(false);

  useEffect(() => {
    const handleLocalChange = () => {
      const storedValue = localStorage.getItem("ps10003000");
      setStopAnimation(!!storedValue);
    };

    handleLocalChange();

    window.addEventListener("localStorageChangedPwa", handleLocalChange);
    return () => {
      window.removeEventListener("localStorageChangedPwa", handleLocalChange);
    };
  }, []);

  const handleClick = () => {
    localStorage.removeItem("ps10003000");
    window.dispatchEvent(new Event("localStorageChangedPwa"));
  };

  return (
    <button
      className={`download-button  ${!stopAnimation ? "animate" : ""}`}
      onClick={handleClick}
    >
      <span className="download-icon">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="12" cy="12" r="12" fill={"var(--positive_bg_color)"} />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM15.8092 11.3333L15.0548 10.5791L12.5712 13.0627V6H11.5045V13.0627L9.02093 10.5791L8.26668 11.3333L12.0379 15.1045L15.8092 11.3333ZM7.2 17.2V16.1333H16.8V17.2H7.2Z"
            fill="white"
          />
        </svg>
      </span>
    </button>
  );
}
